module.exports = __webpack_public_path__ + "static/media/arrow_right.701e0b24.svg";